import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import type { Sport } from "../types/activity";

let sportsCache: Sport[] | null = null;

export const trainingTypeService = {
  async fetchSports(): Promise<Sport[]> {
    if (sportsCache) return sportsCache;
    const snap = await getDocs(collection(db, "sports"));
    const sports = snap.docs.map((item) => ({
      id: item.id,
      ...(item.data() as Omit<Sport, "id">),
    }));
    sports.sort((a, b) => a.name.localeCompare(b.name));
    sportsCache = sports;
    return sports;
  },
};
